import { render } from "./RemoteUsersAdd.vue?vue&type=template&id=27b2fdd5&scoped=true&ts=true"
import script from "./RemoteUsersAdd.vue?vue&type=script&lang=ts"
export * from "./RemoteUsersAdd.vue?vue&type=script&lang=ts"

import "./RemoteUsersAdd.vue?vue&type=style&index=0&id=27b2fdd5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b2fdd5"]])

export default __exports__